import { Button } from 'fronton-react';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
	SwiperContainer,
	SwiperWrapper,
} from 'containers/catalogue/popular-categories/components/popular-categories-slider/styles';
import { btnClassName, wrapperClassName } from './styles';

export type OptionsButtonItem = { text: string; optionName: string };
export type ButtonListProps = {
	value: string;
	onChange: (filter: string) => void;
	optionButtons: OptionsButtonItem[];
};
export const ButtonsList = ({ value, onChange, optionButtons }: ButtonListProps) => (
	<SwiperWrapper>
		<Swiper
			observeSlideChildren
			watchSlidesProgress
			className={`${SwiperContainer} ${wrapperClassName}`}
			slidesPerView="auto"
			style={{ marginTop: '0px' }}
		>
			{optionButtons.map(({ optionName, text }) => (
				<SwiperSlide style={{ width: 'max-content' }} key={text}>
					<Button
						size="l"
						kind="regular"
						variant={value === optionName ? 'primary' : 'secondary'}
						onClick={() => onChange(optionName)}
						className={btnClassName}
						data-qa="option-button"
					>
						{text}
					</Button>
				</SwiperSlide>
			))}
		</Swiper>
	</SwiperWrapper>
);
